import { ExpenseTriggers } from '../../../dependencies';

export const { expenseTriggers } = ExpenseTriggers.entityReducers;
export { default as expenses } from './expenses';
